exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-width[data-v-a543a6d8] {\n\t\twidth: 203px;\n}\n.down-template[data-v-a543a6d8] {\n\t\ttext-decoration: underline;\n\t\tcolor: rgb(38, 166, 222);\n\t\tfont-weight: 400;\n\t\tfont-style: normal;\n\t\tfont-size: 13px;\n\t\tline-height: 13px;\n\t\tmargin: 20px 0px 0px 10px;\n\t\tcursor: pointer;\n}\n.ruku[data-v-a543a6d8]{\n        color:#000000;\n}\n.pagination-container[data-v-a543a6d8] {\n\t\tbackground: #fff;\n\t\tpadding: 20px 16px;\n}\n.pagination-container.hidden[data-v-a543a6d8] {\n\t\tdisplay: none;\n}\n\n", ""]);

// exports
